import { render, staticRenderFns } from "./ChargeWrapper.vue?vue&type=template&id=60a988d2&scoped=true&"
import script from "./ChargeWrapper.vue?vue&type=script&lang=js&"
export * from "./ChargeWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChargeWrapper.vue?vue&type=style&index=0&id=60a988d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a988d2",
  null
  
)

export default component.exports